import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { GridDefinition } from '../../DTO/grid/grid-definition';
import { mergeMap, map } from 'rxjs/operators';
import { WebApiService } from 'src/app/shared/web-api/web-api.service';
import { QueryService } from '../../query/query.service';

@Injectable({
  providedIn: 'root'
})
export class GridService {

  constructor(private webApiService: WebApiService, private queryService: QueryService) { }

  getGridDefinition(
    projectId: string,
    gridName: string
  ): Observable<GridDefinition> {
    // get grid IDs
    // get data
    return this.webApiService.get<GridDefinition>(`/configuration/projects/${projectId}/groups/${gridName}/griddefinitions/default`);
  }

  postSystemsDetailsGrid(gridName: string): Observable<GridDefinition> {
    // get grid IDs
    // get data

    let grid = new GridDefinition();
    return this.webApiService.get<any>(`/configuration/system/griddefinitions`).pipe(
      mergeMap(response => {
        let gridId = "";
        response.forEach(element => {
          if (element.Name === gridName) {
            gridId = element.Id;
          }
        });
        if (gridId !== "") {
          // get grid definitions
          return this.webApiService
            .get<GridDefinition>(`/configuration/system/griddefinitions/${gridId}`)
            .pipe(
              map(detailsResponse => {
                grid = detailsResponse;
                return grid;
              })
            );
        } else {
          return of(null);
        }
      })
    );
  }

  postDataGridQuery(gridId, query) {
    return this.queryService.postDataGridQuery(gridId, query);
  }
}
